import { trpc } from "../trpc";
import { useEntitlements } from "./useEntitlements";

function useAccountRestriction() {
  const { entitlements, isLoading: entitlementsLoading } = useEntitlements();

  const isApprovalRequestsEnabled =
    entitlements?.limits?.isApprovalRequestsEnabled;

  const {
    data,
    isLoading: isAccountRestrictionLoading,
    isPending: isPendingAccountRestrictionLoading,
  } = trpc.account.accountRestriction.useQuery();

  return {
    isLoading: entitlementsLoading || isAccountRestrictionLoading,
    isPending: isPendingAccountRestrictionLoading,
    isPublishApprovalEnabled:
      isApprovalRequestsEnabled && (data?.approvalRequired || false),
  };
}

export default useAccountRestriction;
